export function TableExportIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_0_1616)">
        <path
          d="M3.33411 14.167V15.8337C3.33411 16.2757 3.5097 16.6996 3.82226 17.0122C4.13482 17.3247 4.55875 17.5003 5.00077 17.5003H15.0008C15.4428 17.5003 15.8667 17.3247 16.1793 17.0122C16.4918 16.6996 16.6674 16.2757 16.6674 15.8337V14.167"
          stroke="#767676"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83411 9.16699L10.0008 13.3337L14.1674 9.16699"
          stroke="#767676"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9.99988 3.33337V13.3334" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_0_1616">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
